import React, { Component } from 'react';
import drawSpider from './helpers/drawSpider';
import PropTypes from 'prop-types';
import PersonalityScales from './constants/PersonalityScales';
import PersonalityGraphTexts from './constants/PersonalityGraphTexts';
import SectionBlock from './../SectionBlock/SectionBlock';
import Circle from './components/Circle';
import ExpandText from './../ExpandText/ExpandText';
import ReportSectionHeading from './../ReportSectionHeading/ReportSectionHeading';
import style from './style/personalitygraph.scss';

const colors = {
    belowAverage: 'rgb(220,216,205)',
    average: 'rgb(124,188,216)',
    aboveAverage: 'rgb(12,92,128)',
    mean: 'rgb(231,231,231)',
    beige: 'rgb(219,216,204)',
    gray: 'rgb(72,72,72)',
    white: 'rgb(255,255,255)'
};

export default class PersonalityGraph extends Component {
    constructor(props) {
        super(props);

        this.state = {
            svg: null
        };

        this.buildGraph = this.buildGraph.bind(this);
        this.getScaleScore = this.getScaleScore.bind(this);
        this.getScaleText = this.getScaleText.bind(this);
    }

    getScaleScore(handle) {
        const { scores } = this.props;

        if (scores.filter(score => score.handle === handle) && scores.filter(score => score.handle === handle)[0]) {
            return scores.filter(score => score.handle === handle)[0].score;
        }

        return null;
    }

    getScaleText(handle) {
        const { participantLanguage } = this.props;

        if (PersonalityGraphTexts[participantLanguage][handle]) {
            return PersonalityGraphTexts[participantLanguage][handle];
        }

        return null;
    }

    buildTest() {
        return Circle.create()
            .size(20, 20, 20)
            .fillColor('red')
            .element();
    }

    buildGraph() {
        const D = 600;

        return drawSpider(D, colors, [
            {
                text: this.getScaleText(PersonalityScales.EXTRAVERSION),
                score: this.getScaleScore(PersonalityScales.EXTRAVERSION),
                subscales: [
                    {
                        text: this.getScaleText(PersonalityScales.ENERGY),
                        score: this.getScaleScore(PersonalityScales.ENERGY)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.DOMINANCE),
                        score: this.getScaleScore(PersonalityScales.DOMINANCE)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.SOCIABILITY),
                        score: this.getScaleScore(PersonalityScales.SOCIABILITY)
                    }
                ]
            },
            {
                text: this.getScaleText(PersonalityScales.EMOTIONAL_STABILITY),
                score: this.getScaleScore(PersonalityScales.EMOTIONAL_STABILITY),
                subscales: [
                    {
                        text: this.getScaleText(PersonalityScales.RELATIONAL_STRESS_TOLERANCE),
                        score: this.getScaleScore(PersonalityScales.RELATIONAL_STRESS_TOLERANCE)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.DOWN_TO_EARTH),
                        score: this.getScaleScore(PersonalityScales.DOWN_TO_EARTH)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.TASK_RELATED_STRESS_TOLERANCE),
                        score: this.getScaleScore(PersonalityScales.TASK_RELATED_STRESS_TOLERANCE)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.OPTIMISM),
                        score: this.getScaleScore(PersonalityScales.OPTIMISM)
                    }
                ]
            },
            {
                text: this.getScaleText(PersonalityScales.MILDNESS),
                score: this.getScaleScore(PersonalityScales.MILDNESS),
                subscales: [
                    {
                        text: this.getScaleText(PersonalityScales.HELPFULNESS),
                        score: this.getScaleScore(PersonalityScales.HELPFULNESS)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.TRUST),
                        score: this.getScaleScore(PersonalityScales.TRUST)
                    }
                ]
            },
            {
                text: this.getScaleText(PersonalityScales.OPEN_MINDNESS),
                score: this.getScaleScore(PersonalityScales.OPEN_MINDNESS),
                subscales: [
                    {
                        text: this.getScaleText(PersonalityScales.IMAGINATION),
                        score: this.getScaleScore(PersonalityScales.IMAGINATION)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.INDEPENDENT_THINKING),
                        score: this.getScaleScore(PersonalityScales.INDEPENDENT_THINKING)
                    }
                ]
            },
            {
                text: this.getScaleText(PersonalityScales.CONSCIENTIOUSNESS),
                score: this.getScaleScore(PersonalityScales.CONSCIENTIOUSNESS),
                subscales: [
                    {
                        text: this.getScaleText(PersonalityScales.RESPONSIBILITY),
                        score: this.getScaleScore(PersonalityScales.RESPONSIBILITY)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.SELF_DISCIPLINE),
                        score: this.getScaleScore(PersonalityScales.SELF_DISCIPLINE)
                    },
                    {
                        text: this.getScaleText(PersonalityScales.WORKING_SYSTEMATICALLY),
                        score: this.getScaleScore(PersonalityScales.WORKING_SYSTEMATICALLY)
                    }
                ]
            }
        ]);
    }

    render() {
        const {
            classes,
            i18nParticipation,
            scores,
            introduction,
            iconText,
            resizeSection,
            index,
            handle,
            expanded
        } = this.props;

        let scoresPresent = true;

        // check to see if all expected personality scales are present in the scores object
        Object.keys(PersonalityScales).forEach(scale => {
            if (!scores.filter(score => score.handle === PersonalityScales[scale])[0]) {
                scoresPresent = false;
            }
        });

        if (!scoresPresent) {
            return null;
        }

        return (
            <SectionBlock classes={{
                root: `${style.personalityGraphWrapper} ${classes.root}`,
                contentWrapper: classes.contentWrapper
            }}>
                <div className={ style.personalityGraph }>

                    <ReportSectionHeading
                        title={ i18nParticipation.report_personality_section_title }
                        iconType={ 'desktop' }
                        iconText={ iconText }
                        introHeading={ false }
                        classes={{
                            roundIcon: {
                                root: classes.roundIcon.root,
                                roundIconFigureWrapper: classes.roundIcon.roundIconFigureWrapper
                            }
                        }}
                    />

                    { introduction
                        ? <ExpandText
                            text={ introduction }
                            classes={{
                                root: style.expandText__reportSection
                            }}
                            resize={ resizeSection ? event => resizeSection(event, index, handle) : null }
                            index={ index || null }
                            handle={ handle || null }
                            expanded={ expanded || false }
                        />
                        : null }
                    <div className={ style.svgWrapper }>
                        { this.buildGraph() }
                    </div>
                    <ul className={ style.personalityGraphLegend }>
                        <li
                            style={{ color: colors.aboveAverage }}
                            className={ style.personalityGraphLegendIcon }
                        >
                            <span>{ i18nParticipation.report_personality_high }</span>
                        </li>
                        <li
                            style={{ color: colors.average }}
                            className={ style.personalityGraphLegendIcon }
                        >
                            <span>{ i18nParticipation.report_personality_medium }</span>
                        </li>
                        <li
                            style={{ color: colors.belowAverage }}
                            className={ style.personalityGraphLegendIcon }
                        >
                            <span>{ i18nParticipation.report_personality_low }</span>
                        </li>
                    </ul>
                </div>
            </SectionBlock>
        );
    }
}

PersonalityGraph.propTypes = {
    participantLanguage: PropTypes.oneOf(['nl-NL', 'en-GB', 'de-DE', 'fr-FR']).isRequired,
    i18nParticipation: PropTypes.object.isRequired,
    scores: PropTypes.arrayOf(PropTypes.shape({
        handle: PropTypes.string.isRequired,
        score: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number
        ]).isRequired
    })).isRequired,
    introduction: PropTypes.string,
    resizeSection: PropTypes.func,
    index: PropTypes.number,
    expanded: PropTypes.bool,
    handle: PropTypes.string,
    classes: PropTypes.object
};

PersonalityGraph.defaultProps = {
    classes: {
        root: '',
        roundIcon: {
            root: '',
            roundIconFigureWrapper: ''
        },
        contentWrapper: ''
    }
};
